module.exports = __webpack_public_path__ + "static/media/redeprof.6f300d27.svg";